import { render } from "./OverlayLoading.vue?vue&type=template&id=f4ebf6f8&scoped=true"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"

import "./OverlayLoading.vue?vue&type=style&index=0&id=f4ebf6f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4ebf6f8"]])

export default __exports__